import React, { FC } from 'react';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import { cancellationTranslate } from '../_constants/rulesConstants';
import styles from './CancellationRulesCard.module.scss';
type CancellationRulesCardTypes = {
  cancellationRule: (typeof cancellationTranslate)[keyof typeof cancellationTranslate];
  isMidterm: boolean;
};
const CancellationRulesCard: FC<CancellationRulesCardTypes> = ({
  cancellationRule,
  isMidterm
}) => {
  return <Box className={styles['cancellation-rules-card']} data-sentry-element="Box" data-sentry-component="CancellationRulesCard" data-sentry-source-file="CancellationRulesCard.tsx">
      <Box data-sentry-element="Box" data-sentry-source-file="CancellationRulesCard.tsx">
        <Box className={styles['cancellation-rules-card-header']} data-sentry-element="Box" data-sentry-source-file="CancellationRulesCard.tsx">
          <Icon name="note-remove" type="highEmphasis" data-sentry-element="Icon" data-sentry-source-file="CancellationRulesCard.tsx" />
          <Typography variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="CancellationRulesCard.tsx">
            قوانین لغو رزرو{' '}
            <Typography variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="CancellationRulesCard.tsx">
              {isMidterm ? `بلندمدت` : `(${cancellationRule})`}
            </Typography>
          </Typography>
        </Box>
        <Typography variant="bodyM" className={styles['cancellation-rules-card-description']} data-sentry-element="Typography" data-sentry-source-file="CancellationRulesCard.tsx">
          مشاهده دقیق جزئیات لغو رزرو اقامتگاه
        </Typography>
      </Box>
      <Box className={styles['cancellation-rules-card-left-icon']} data-sentry-element="Box" data-sentry-source-file="CancellationRulesCard.tsx">
        <Icon name="arrow-left-1" type="highEmphasis" data-sentry-element="Icon" data-sentry-source-file="CancellationRulesCard.tsx" />
      </Box>
    </Box>;
};
export default CancellationRulesCard;